import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState
} from "react";
import { Scrollbars } from "react-custom-scrollbars";
import cn from "clsx";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "@/redux/store";
import { changeSelectedCountry } from "@/redux/actions/storeLocator.action";
import { StoreLocatorContext } from "@/routes/storeLocator/storeLocator";
import { isServer } from "@/util";

const StoreLocatorHeaderWeb = () => {
  const [showDropDown, setShowDropDown] = useState(false);

  const { t } = useTranslation("storeLocator");
  const dispatch = useAppDispatch();
  const inputBoxRef = useRef(null);
  const dropdowmWrapperRef = useRef(null);

  const {
    handleCurrentLocation,
    selectedCountry,
    selectedShop,
    handleChangeSelectedShop
  } = useContext(StoreLocatorContext);

  const cityList = useAppSelector(state => state.storeLocatorReducer.cityList);
  const storeCountry = useAppSelector(
    state => state.storeLocatorReducer.storeCountry
  );

  const handleShowDropdown = () => setShowDropDown(prev => !prev);

  const handleSelectedShop = selectedShop => {
    handleChangeSelectedShop({ shopItem: selectedShop });
    handleShowDropdown();
  };

  const handleClickOutside = event => {
    if (
      dropdowmWrapperRef &&
      !dropdowmWrapperRef.current?.contains(event.target) &&
      !(inputBoxRef && inputBoxRef.current?.contains(event.target))
    ) {
      setShowDropDown(false);
    }
  };

  useEffect(() => {
    !isServer && document.addEventListener("mousedown", handleClickOutside);

    return () => {
      !isServer &&
        document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const totalStoresCount =
    cityList &&
    cityList.map(key => key["shops"].length).reduce((a, b) => a + b, 0);

  return (
    <div className="store-header-conatiner">
      <div className="store-header-wrapper">
        <h2 className="store-locator-heading">{t("storeHeader")}</h2>
        <div className="store-locator-dropdown-box-wrapper">
          <div
            className="store-locator-dropdown-box"
            ref={inputBoxRef}
            onClick={handleShowDropdown}
          >
            <div className="inner-content">
              <span className="mainSelected">
                {`${selectedShop.countryName || ""}${
                  selectedShop.countryName ? "," : ""
                } ${selectedShop.name || ""}`}
              </span>
              {totalStoresCount > 1 && (
                <span className="otherLocation">
                  {" "}
                  {totalStoresCount - 1} Other store location in{" "}
                  <em>{selectedCountry}</em>
                </span>
              )}
            </div>
          </div>
          <div className="store-locator-button-wrapper">
            <button onClick={handleCurrentLocation}>
              <span className="current-location-icon" />
              {t("useMyCurrentLocation")}
            </button>
          </div>
        </div>
        {showDropDown && (
          <div
            className="store-locator-dropdown-wrapper"
            ref={dropdowmWrapperRef}
          >
            <Scrollbars autoHeight autoHeightMax={439} className="left-col">
              <ul>
                {storeCountry &&
                  storeCountry.map((item, index) => (
                    <li
                      className={cn("city-name", {
                        active: item === selectedCountry
                      })}
                      onClick={() => dispatch(changeSelectedCountry(item))}
                      key={`${item}-${index}`}
                    >
                      {item}
                    </li>
                  ))}
              </ul>
            </Scrollbars>

            <Scrollbars autoHeight autoHeightMax={439} className="right-col">
              <div>
                <ul>
                  {cityList &&
                    cityList.map((item, index) => (
                      <Fragment key={`${item.city}-${index}`}>
                        <li className={`city-name`}>{item.city}</li>
                        {item.shops &&
                          !!item.shops.length &&
                          item.shops.map((shopItem, shopIndex) => (
                            <li
                              onClick={() =>
                                handleSelectedShop({
                                  ...shopItem,
                                  city: item.city
                                })
                              }
                              key={shopItem.shopId || shopIndex}
                            >
                              {shopItem.name}
                            </li>
                          ))}
                      </Fragment>
                    ))}
                </ul>
              </div>
            </Scrollbars>
          </div>
        )}
      </div>
    </div>
  );
};

export default StoreLocatorHeaderWeb;
